import { addWhiteSpaces, createDomElement, Formatter, isNumber, SlickDataView } from "slickgrid-react";
import type { SlickgridReactInstance } from "slickgrid-react";


export const getFileIcon = (value: string) => {
  let prefix = '';
  if (value.includes('.pdf')) {
    prefix = '<span class="mdi mdi-file-pdf-outline text-danger"></span>';
  } else if (value.includes('.txt')) {
    prefix = '<span class="mdi mdi-file-document-outline"></span>';
  } else if (value.includes('.xls')) {
    prefix = '<span class="mdi mdi-file-excel-outline text-primary"></span>';
  } else if (value.includes('.mp3')) {
    prefix = '<span class="mdi mdi-file-music-outline text-info"></span>';
  }
  return prefix;
}

// 树下拉箭头自定义渲染
export const treeFormatter: Formatter = (_row, _cell, value, _columnDef, dataContext, grid) => {
  const gridOptions = grid.getOptions();
  const treeLevelPropName = gridOptions.treeDataOptions && gridOptions.treeDataOptions.levelPropName || '__treeLevel';
  if (value === null || value === undefined || dataContext === undefined) {
    return '';
  }
  const dataView = grid.getData<SlickDataView>();
  const data = dataView.getItems();
  const identifierPropName = dataView.getIdPropertyName() || 'id';
  const idx = dataView.getIdxById(dataContext[identifierPropName]) as number;
  const prefix = getFileIcon(value);
  const treeLevel = dataContext[treeLevelPropName];
  const exportIndentationLeadingChar = '';
  value = value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  // Create spacer with vertical lines
  const spacer = Array.from({ length: treeLevel }).map(() => `<span class="tree-vertical-line" style="margin-left: -4px"></span>`).join('');

  const indentSpacer = addWhiteSpaces(5 * treeLevel);

  // 如果节点正在加载中
  // if (dataContext.__loading) {
  //   const mlClass = treeLevel == 0 ? 'ml-3' : '';
  //   return `<span class="slickgrid_cutom_value_tip" title=${value}>
  //     <span class="hidden">${exportIndentationLeadingChar}</span>${spacer}${indentSpacer} 
  //     <span class="slick-group-toggle loading slickgrid_cutom_toggle ${mlClass}" style="${treeLevel != 0 ? 'margin-left: -4px' : ''}" level="${treeLevel}">
  //       <span class="loading-spinner"></span>
  //     </span>
  //     ${prefix} <span class="slickgrid_cutom_value" title=${value}>${value}</span>
  //   </span>`;
  // }

  if (data?.[idx + 1]?.[treeLevelPropName] > data?.[idx]?.[treeLevelPropName] || data?.[idx]?.['__hasChildren']) {
    const folderPrefix = ``;
    const mlClass = treeLevel == 0 ? 'ml-3' : '';
    if (dataContext.__collapsed) {
      return `<span class="slickgrid_cutom_value_tip" title=${value}><span class="hidden">${exportIndentationLeadingChar}</span>${spacer}${indentSpacer} <span class="slick-group-toggle collapsed slickgrid_cutom_toggle ${mlClass}" style="${treeLevel != 0 ? 'margin-left: -4px' : ''}" level="${treeLevel}"></span>${folderPrefix} ${prefix} <span class="slickgrid_cutom_value" title=${value}><span >${value}</span></span></span>`;
    }
    return `<span class="slickgrid_cutom_value_tip" title=${value}><span class="hidden">${exportIndentationLeadingChar}</span>${spacer}${indentSpacer} <span class="slick-group-toggle expanded slickgrid_cutom_toggle ${mlClass}" style="${treeLevel != 0 ? 'margin-left: -4px' : ''}" level="${treeLevel}"></span>${folderPrefix} ${prefix} <span class="slickgrid_cutom_value"  title=${value}>${value}</span></span>`;
  }
  return `<span class="slickgrid_cutom_value_tip" title=${value}><span class="hidden">${exportIndentationLeadingChar}</span>${spacer}${indentSpacer} <span class="slick-group-toggle slickgrid_cutom_toggle" style="${treeLevel != 0 ? 'margin-left: -4px' : ''}" level="${treeLevel}"></span>${prefix} <span class="slickgrid_cutom_value"  title=${value}>${value}</span></span>`;
};


export const checkmarkMaterialFormatter: Formatter = (_row, _cell, value) => {
  let isChecked = false;
  const isValidNumber = isNumber(value);

  if (isValidNumber) {
    value = +value; // convert to number before doing next condition
  }

  if (value === true || (isValidNumber && +value > 0) || (typeof value === 'string' && value.length > 0 && value.toLowerCase() !== 'false' && value !== '0')) {
    isChecked = true;
  }

  return isChecked ? createDomElement('i', { className: 'mdi mdi-18px mdi-check checkmark-icon', ariaHidden: 'true' }) : '';
};

type ReplaceTreeDataItemsOptions = {
  idProperty?: string
  preservePosition?: boolean
  preserveSelection?: boolean
}

const walkTree = (items: any[] | undefined, callback: (item: any) => void) => {
  const treeItems = items || []
  treeItems.forEach(item => {
    callback(item)
    if (Array.isArray(item?.children) && item.children.length > 0) {
      walkTree(item.children, callback)
    }
  })
}

const restoreHorizontalScroll = (slickGrid: any, scrollLeft: number) => {
  const viewports = slickGrid?.getViewports?.() || []
  viewports.forEach((viewport: HTMLElement) => {
    const targetViewport = viewport
    targetViewport.scrollLeft = scrollLeft
  })
}

export const replaceTreeDataItems = (
  reactGrid: SlickgridReactInstance | null | undefined,
  treeData: any[],
  options: ReplaceTreeDataItemsOptions = {}
) => {
  if (!reactGrid?.dataView || !reactGrid?.slickGrid || !Array.isArray(treeData)) {
    return false
  }

  const { slickGrid, dataView, treeDataService, filterService } = reactGrid
  const slickGridAny = slickGrid as any
  const idProperty = options.idProperty || slickGrid.getOptions?.()?.datasetIdPropertyName || dataView.getIdPropertyName?.() || 'id'
  const previousItems = dataView.getItems?.() || []

  // 这里对应“单次修改匹配”的思路：数据更新直接写 SlickGrid DataView。
  // 只是批量/重置需要重新取一份完整树数据，所以先记录滚动、选中和展开状态，setItems 后再恢复。
  const scrollTop = typeof slickGridAny.scrollTop === 'number' ? slickGridAny.scrollTop : 0
  const scrollLeft = typeof slickGridAny.scrollLeft === 'number'
    ? slickGridAny.scrollLeft
    : slickGrid.getViewports?.()?.[0]?.scrollLeft || 0
  const activeCell = slickGrid.getActiveCell?.()
  const activeItemId = activeCell ? previousItems[activeCell.row]?.[idProperty] : undefined
  const selectedItemIds = options.preserveSelection === false
    ? []
    : (slickGrid.getSelectedRows?.() || [])
      .map((row: number) => previousItems[row]?.[idProperty])
      .filter((id: any) => id !== undefined && id !== null)

  const collapsedMap = new Map<any, boolean>()
  previousItems.forEach(item => {
    const id = item?.[idProperty]
    if (id !== undefined && id !== null && item['__collapsed'] !== undefined) {
      collapsedMap.set(id, item['__collapsed'])
    }
  })
  if (collapsedMap.size > 0) {
    walkTree(treeData, item => {
      const id = item?.[idProperty]
      if (collapsedMap.has(id)) {
        Object.assign(item, { ['__collapsed']: collapsedMap.get(id) })
      }
    })
  }

  const sortedDataset = treeDataService?.sortHierarchicalDataset
    ? treeDataService.sortHierarchicalDataset(treeData)
    : { hierarchical: treeData, flat: treeData }
  const flatItems = sortedDataset?.flat || treeData
  const treeDataServiceAny = treeDataService as any

  // SlickGrid 树表内部展示的是 flat items，同时还需要同步 hierarchicalDataset，
  // 否则后续展开/收起、过滤会拿到旧树数据。
  if (treeDataServiceAny?.sharedService) {
    treeDataServiceAny.sharedService.hierarchicalDataset = sortedDataset?.hierarchical || treeData
  }

  dataView.setItems(flatItems, idProperty)
  filterService?.refreshTreeDataFilters?.(flatItems)
  slickGrid.invalidate?.()
  slickGrid.render?.()

  if (options.preservePosition === false) {
    return true
  }

  const restorePosition = () => {
    slickGrid.scrollTo?.(scrollTop)
    restoreHorizontalScroll(slickGrid, scrollLeft)

    if (selectedItemIds.length > 0) {
      const rows = selectedItemIds
        .map((id: any) => dataView.getRowById?.(id))
        .filter((row: number | undefined) => typeof row === 'number' && row >= 0) as number[]
      if (rows.length > 0) {
        slickGrid.setSelectedRows?.(rows)
      }
    }

    if (activeCell && activeItemId !== undefined && activeItemId !== null) {
      const activeRow = dataView.getRowById?.(activeItemId)
      if (typeof activeRow === 'number' && activeRow >= 0) {
        slickGrid.setActiveCell?.(activeRow, activeCell.cell)
      }
    }
  }

  restorePosition()
  window.requestAnimationFrame?.(restorePosition)
  return true
}

export const replaceArrayItemsInPlace = <T = any>(target: T[], source: T[]) => {
  if (!Array.isArray(target) || !Array.isArray(source)) {
    return source
  }
  target.splice(0, target.length, ...source)
  return target
}
